import BenchlingConfig from 'BenchlingConfig';

/**
 * Whether Mixture Prep structured tables (metadata and ingredients) may participate in Table Mapping,
 * either as a source or as a destination.
 *
 * Mixture Prep tables only appear in the entry-level evaluation snapshot (keyed by table name) when
 * `ENABLE_MIXTURE_PREP_ENTRY_EVALUATION` is on. Table Mapping execution reads evaluated source values
 * from that snapshot, so mixture table mapping is hard-gated on the same flag.
 */
export default function isMixtureTableMappingEnabled(): boolean {
  return BenchlingConfig.ENABLE_MIXTURE_PREP_ENTRY_EVALUATION;
}
